import React from "react";
import img from "../../../assets/img/Home/cover-img (4).png";
import profile from "../../../assets/img/Home/profile.png";
import location from "../../../assets/img/icons/location-bbold-green.svg";
import calander from "../../../assets/img/checkout/calendar-tick.svg";
import security from "../../../assets/img/checkout/security-time.svg";
import clipboard from "../../../assets/img/checkout/clipboard-text.svg";
import ReserveCounts from "../userPanel/userstatics/ReserveCounts";
import moment from "jalali-moment";
import useFetch from "../../../hooks/useAxios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const PaymentDetailBox = ({ inforesidencedetail, reserveinfodetail }) => {
  const {code,slug,id}=useParams()
 const navigate = useNavigate()
  const apiCancleReserve = useFetch({
    method: "put",
    url: `api/guest/reserve/cancel/${id}`,
    noHeader: false,
    trigger: false,
    argFunc:(res)=>{
      navigate(`/place/${code}/${slug}`);
      toast.success("لغو رزرو با موفقیت انجام شد.")
    }
    
   
  });
  return (
    <div className="PaymentDetailBox">
      <div className="flex gap-[16px] items-stretch w-[30%]">
        <img src={inforesidencedetail.thumbnail.path} className="PaymentDetailBox--img" />
        <div>
          <div className="center w-max py-[6px] px-[16px] bg-[#F1C31F] rounded-[50px] text-[16px] font-[600] text-[#12171C] flex justify-center items-center">
            <p className="">کد آگهی :</p>
            <p>
              {inforesidencedetail.code}
            </p>
          </div>
          <h3>
            {inforesidencedetail.title}
          </h3>
          <div className="PaymentDetailBox--location flex gap-[8px] items-center">
            <img src={location} />
            <div>
              استان {inforesidencedetail.city.state} ،{" "}
              {inforesidencedetail.city.title}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-col">
        <div className="flex gap-[10px]">
          <img width={60} height={60} src={reserveinfodetail.user.avatar} />
          <div>
            <p>میزبان شما</p>
            <h6>
              {inforesidencedetail.user.full_name}{" "}
            </h6>
          </div>
        </div>
        <div className="flex gap-[10px]">
          <img src={calander} />
          <div>
            <p>مسافر ها</p>
            <h6>
              {reserveinfodetail.guests_count >= inforesidencedetail.capacity
                ? inforesidencedetail.capacity
                : reserveinfodetail.guests_count}{" "}
              مسافر +
               {reserveinfodetail.guests_count >= inforesidencedetail.capacity ?
               reserveinfodetail.guests_count - inforesidencedetail.capacity :
               0

               } مسافر اضافه
            </h6>
          </div>
        </div>
      </div>
      <div className="flex-col">
        <div className="flex gap-[10px]">
          <img src={security} />
          <div>
            <p>تاریخ سفر</p>
            <h6>{reserveinfodetail.reserve_to_date}تا{ reserveinfodetail.reserve_from_date} </h6>
          </div>
        </div>
        <div className="flex gap-[10px]">
          <img src={clipboard} />
          <div>
            <p>مشخصات</p>
            <h6>{inforesidencedetail.area_size} متری ، {inforesidencedetail.rooms_count} خواب ، {inforesidencedetail.space} </h6>
          </div>
        </div>
      </div>
      <button className="red-bg" onClick={()=>apiCancleReserve.reFetch()}>لغو رزرو</button>
    </div>
  );
};

export default PaymentDetailBox;
